import AWBList from '@/components/awb/AWBList';
import React from 'react';

const AWBManagement: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-6">
      <AWBList />
    </div>
  );
};

export default AWBManagement;